<template>
  <div class="MH">
    <div class="MH-logo">
      <img src="@/assets/whitelogo.png" alt />
    </div>

    <Slide right class="MH-Slide" :closeOnNavigation="true">
      <router-link to="company">
        <span>COMPANY</span>
      </router-link>
      <router-link to="product">
        <span>PRODUCT</span>
      </router-link>
      <router-link to="joinus">
        <span>JOIN US</span>
      </router-link>
      <router-link to="contactus">
        <span>CONTACT US</span>
      </router-link>
    </Slide>
  </div>
</template>
<script>
// import Menu from "vue-material-design-icons/Menu"
import { Slide } from "vue-burger-menu";
export default {
  name: "MobileHeader",
  components: {
    // Menu,
    Slide
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.MH {
  width: 100%;
  height: 65px;
  background-color: rgba(0, 0, 0, 0.4);
  // display: flex;
  // flex-direction: row;
  // align-items: center;
  // justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  padding: 15px;
  box-sizing: border-box;

  .MH-logo {
    width: 50%;
    height: 30px;
    overflow: hidden;
    position: relative;

    img {
      height: 100%;
    }
  }
}
</style>
<style lang="scss">
.MH-Slide {
  .bm-burger-button {
    position: fixed;
    width: 28px;
    height: 24px;
    /* left: 36px;
      top: 36px; */
    top: 17px;
    right: 20px !important;
    cursor: pointer;
  }

  .bm-burger-bars {
    background-color: #ffffff;
  }

  .line-style {
    position: absolute;
    height: 10%;
    left: 0;
    right: 0;
  }

  .cross-style {
    position: absolute;
    top: 30px;
    right: 10px;
    cursor: pointer;
  }

  .bm-cross {
    background: #ffffff;
  }

  .bm-cross-button {
    height: 24px;
    width: 24px;
  }

  .bm-menu {
    height: 100% !important;
    /* 100% Full-height */
    width: 0;
    /* 0 width - change this with JavaScript */
    position: fixed;
    /* Stay in place */
    z-index: 1000;
    /* Stay on top */
    top: 0;
    left: 0;
    background-color: #00a79d;
    /* Black*/
    overflow-x: hidden;
    /* Disable horizontal scroll */
    padding-top: 60px;
    /* Place content 60px from the top */
    transition: 0.5s;
    /*0.5 second transition effect to slide in the sidenav*/
  }

  .bm-overlay {
    background: rgba(0, 0, 0, 0.3);
  }

  .bm-item-list {
    color: #b8b7ad;
    margin-left: 10%;
    font-size: 20px;
  }

  .bm-item-list > * {
    display: flex;
    text-decoration: none;
    padding: 0.7em;
  }

  .bm-item-list > * > span {
    margin-left: 10px;
    font-weight: 700;
    color: white;
  }
}
</style>